import { useEffect, useState } from 'react';
import { disableAnalytics, initAnalytics } from '@/services/observability/analytics';
import {
  getCookieConsent,
  onOpenCookiePreferences,
  saveCookieConsent,
  type CookieConsent,
} from '@/services/privacy/cookieConsent';
import './CookieConsentBanner.css';

export const CookieConsentBanner = () => {
  const [consent, setConsent] = useState<CookieConsent | null>(() => getCookieConsent());
  const [showPreferences, setShowPreferences] = useState(false);
  const [analytics, setAnalytics] = useState(() => consent?.analytics ?? false);

  useEffect(() => {
    const cleanup = onOpenCookiePreferences(() => {
      const current = getCookieConsent();
      setConsent(current);
      setAnalytics(current?.analytics ?? false);
      setShowPreferences(true);
    });
    return cleanup;
  }, []);

  useEffect(() => {
    if (consent?.analytics) initAnalytics();
  }, [consent]);

  const save = (nextAnalytics: boolean) => {
    const next = saveCookieConsent(nextAnalytics);
    setConsent(next);
    setAnalytics(nextAnalytics);
    setShowPreferences(false);
    if (nextAnalytics) initAnalytics();
    else disableAnalytics();
  };

  const open = consent === null || showPreferences;
  if (!open) return null;

  return (
    <aside className="cookie-consent" aria-labelledby="cookie-consent-title" aria-live="polite">
      <div className="cookie-consent-copy">
        <h2 id="cookie-consent-title">Sua privacidade</h2>
        <p>
          Usamos o armazenamento necessário para manter sua escolha. Métricas de uso só são ativadas se você permitir.
        </p>
        <a href="/legal#cookies">Ver política de cookies</a>
      </div>
      <div className="cookie-consent-actions">
        <button type="button" className="cookie-button cookie-button-secondary" onClick={() => save(false)}>
          Recusar analíticos
        </button>
        <button type="button" className="cookie-button cookie-button-primary" onClick={() => save(true)}>
          Aceitar analíticos
        </button>
        <button type="button" className="cookie-text-button" onClick={() => setShowPreferences((openPreferences) => !openPreferences)} aria-expanded={showPreferences}>
          Personalizar
        </button>
      </div>
      {showPreferences && (
        <div className="cookie-preferences" aria-label="Preferências de cookies">
          <div className="cookie-preference-row">
            <div>
              <strong>Necessários</strong>
              <p>Guardam sua escolha de cookies e mantêm recursos básicos da aplicação.</p>
            </div>
            <span aria-label="Sempre ativos">Sempre ativos</span>
          </div>
          <label className="cookie-preference-row">
            <span>
              <strong>Métricas de uso</strong>
              <span>Usadas para entender páginas acessadas e erros, sem incluir e-mail, telefone ou texto livre nos eventos.</span>
            </span>
            <input type="checkbox" checked={analytics} onChange={(event) => setAnalytics(event.target.checked)} />
          </label>
          <button type="button" className="cookie-button cookie-button-primary" onClick={() => save(analytics)}>
            Salvar escolhas
          </button>
        </div>
      )}
    </aside>
  );
};
